export function setNestedAlertSymbol(target: any, symbolValue: string): void {
  if (typeof target !== 'object' || target === null) {
    return
  }

  if (Array.isArray(target)) {
    for (const item of target) {
      setNestedAlertSymbol(item, symbolValue)
    }
  } else {
    for (const key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        if (key === 'symbol') {
          target[key] = symbolValue
        }

        const value = target[key]

        if (typeof value === 'object' && value !== null) {
          setNestedAlertSymbol(value, symbolValue)
        }
      }
    }
  }
}
